import { render, staticRenderFns } from "./PensionInstitution.vue?vue&type=template&id=01a22bd8&scoped=true&"
import script from "./PensionInstitution.vue?vue&type=script&lang=ts&"
export * from "./PensionInstitution.vue?vue&type=script&lang=ts&"
import style0 from "./PensionInstitution.vue?vue&type=style&index=0&id=01a22bd8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a22bd8",
  null
  
)

export default component.exports